const DEFAULT_STATE = {
  showDropTarget: false,
  dropTargetHTML: ''
}

export const dropTargetReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case 'SHOW_DROP_TARGET': {
      return {
        ...state,
        showDropTarget: true,
        dropTargetHTML: action.request.html
      }
    }
    case 'HIDE_DROP_TARGET': {
      return {
        ...state,
        showDropTarget: false,
        dropTargetHTML: ''
      }
    }
    default:
      throw new Error('Unknown action type')
  }
}
